module.exports = __webpack_public_path__ + "static/media/RevForecast.0a5530f7.png";